import React, { useEffect } from "react";
import {
  Select,
  Option,
} from "carbon-react/lib/__experimental__/components/select";
import { supportedLanguages } from "../../../constants/model";

import "./LanguageSelector.css";

const LanguageSelector = ({
  appearBusy,
  required,
  value,
  onValueChanged,
  onBlur,
  appearInvalid,
  validationMsg,
  autoFocus = false,
}) => {
  const labelCaption = `Notification language${required ? " (Required)" : ""}`;

  /*******************************************************
   Set default value where only one available
   
   We cannot set the default state in the parent as this 
   results in the initial state being correct, but the 
   selected value does NOT 'appear to be selected' when 
   the <select> is rendered - potentially because the 
   options have not been rendered?  We can set the 
   default value of the <select> (despite docs saying 
   this doesn't work) but this does NOT invoke the 
   onChange to update the parent state.

   Setting a default value AND invoking an onValueChanged
   after the first render produces the behaviour we want!
  *******************************************************/
  const defaultValue =
    supportedLanguages && supportedLanguages.length === 1
      ? supportedLanguages[0].value
      : null;

  useEffect(() => {
    onValueChanged(defaultValue);
  }, []); // eslint-disable-line
  /*******************************************************/

  const onChange = (selected) => {
    const newValue =
      selected && selected.length > 0 ? selected[0]?.optionValue : null;

    if (onValueChanged && typeof onValueChanged === "function")
      onValueChanged(newValue);
  };

  const onBlurAction = () => {
    if (onBlur && typeof onBlur === "function") onBlur();
  };

  const validationWarning = {
    hasWarning: true,
    inputIcon: "warning",
    tooltipMessage:
      validationMsg && validationMsg.length > 0
        ? validationMsg
        : "Value is mandatory",
  };

  const autoFocusAttributes = {
    autoFocus: true,
  };

  return (
    <div className="language-selector">
      <Select
        id="language-selector-select"
        preventFocusAutoOpen={true}
        filterable={false}
        label={labelCaption}
        labelAlign="left"
        placeholder="Select language..."
        size="medium"
        labelHelp="Completing this action will send an automated notification to the user.  Please select a preferred language."
        disabled={appearBusy}
        value={value}
        defaultValue={defaultValue}
        onChange={(e) => onChange(e?.target?.value)}
        onBlur={onBlurAction}
        {...(autoFocus ? autoFocusAttributes : {})}
        {...(appearInvalid ? validationWarning : {})}
      >
        {supportedLanguages.map((language) => {
          return (
            <Option
              key={language.value}
              text={language.displayValue}
              value={language.value}
            />
          );
        })}
      </Select>
    </div>
  );
};

export default LanguageSelector;
